module.exports = __webpack_public_path__ + "images/3a2fbce6d1406378e366d6c56761801e.svg";